import { Component, Input } from '@angular/core';
import { AlertController  } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'rmt-tooltip',
  templateUrl: 'rmt-tooltip.html'
})
export class RmtTooltipComponent {
  @Input() content: Node;
  @Input() title: string;
  @Input() buttonText: string = this.translate.instant('page.trackTransferPage.tATToolTip.gotItButton');
  @Input() extraCustomClass:string='';
  @Input() icon: string = 'custom-icon-info';
  @Input() mode: string = 'icon';

  constructor(private alertCtrl: AlertController, private translate: TranslateService,) {
  }

  ngAfterViewInit() {
    if (this.content) {
      (<any>this.content).style.display = 'none';
    }
  }

  showTooltip() {
    const alert = this.alertCtrl.create({
      title: this.title,
      cssClass: 'tooltip-alert'+' '+this.extraCustomClass,
      message: '<div class="alert-tooltip"></div>',
      buttons: [{
        text: this.buttonText,
        role: 'cancel'
      }]
    });
    alert.setMode('ios');
    alert.present();
    window.requestAnimationFrame(() => {
      const tooltip = document.getElementsByClassName('alert-tooltip')[0];
      if (this.content.parentNode)
        this.content.parentNode.removeChild(this.content);
      tooltip.appendChild(this.content);
      (<any>this.content).style.display = '';
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-tooltip/rmt-tooltip.ts